import { Action } from '@ngrx/store';
import { EmailDataInterface } from 'app/interfaces/emailData.interface';

export const SET_EMAIL = '[emailSender] Set Email';
export const UNSET_EMAIL = '[emailSender] Unset Email';
export const SET_NAME = '[emailSender] Set Name';
export const UNSET_NAME = '[emailSender] Unset Name';
export const SET_OPERATOR_TYPE = '[emailSender] Set operator type';
export const UNSET_OPERATOR_TYPE = '[emailSender] Unset operator type';

export class SetEmail implements Action {
    readonly type = SET_EMAIL;
    constructor(public email: string) {}
}

export class UnsetEmail implements Action {
    readonly type = UNSET_EMAIL;
}

export class SetName implements Action {
    readonly type = SET_NAME;
    constructor(public name: string) {}
}

export class UnsetName implements Action {
    readonly type = UNSET_NAME;
}

export class SetOperatorType implements Action {
    readonly type = SET_OPERATOR_TYPE;
    constructor(public operatorType: string) {}
}

export class UnsetOperatorType implements Action {
    readonly type = UNSET_OPERATOR_TYPE;
}

export type EmailSenderActions =
    | SetEmail
    | UnsetEmail
    | SetName
    | UnsetName
    | SetOperatorType
    | UnsetOperatorType;
